export function databaseUsers() {
  return [
    { userName: "homalley", name: "Harry", simulations: [1930, 1932] },
    { userName: "jsmith", name: "John", simulations: [1931] }
  ];
}
